import { ResponsiveLine } from '@nivo/line'
import { useTheme } from "@emotion/react";
import { tokens } from "../theme";
import React from "react";
import { Typography, Box } from '@mui/material';

const LineChart = React.memo(({ data = [] }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const chartData = React.useMemo(() => {
        if (!data || !Array.isArray(data) || data.length === 0) {
            return [{
                id: "Revenue",
                data: []
            }];
        }

        if (data.length > 0 && data[0].id && Array.isArray(data[0].data)) {
            return data;
        }

        const transformedData = data
            .filter(item => item && item.date && typeof item.totalRevenue === 'number')
            .map(item => ({
                x: new Date(item.date).toLocaleDateString(),
                y: item.totalRevenue
            }));

        return [{
            id: "Revenue",
            data: transformedData
        }];
    }, [data]);

    const hasData = chartData.some(series =>
        series.data && Array.isArray(series.data) && series.data.length > 0
    );

    if (!hasData) {
        return (
            <Box
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography
                    variant="h3"
                    color={colors.grey[100]}
                    textAlign="center"
                >
                    Aucune donnée disponible
                </Typography>
            </Box>
        );
    }

    return (
        <ResponsiveLine
            data={chartData}
            theme={{
                tooltip: {
                    container: {
                        background: colors.primary[400],
                        color: colors.grey[100],
                        fontSize: 12,
                        borderRadius: "8px",
                    },
                },
                axis: {
                    domain: {
                        line: {
                            stroke: colors.grey[100],
                        },
                    },
                    legend: {
                        text: {
                            fill: colors.grey[100],
                        },
                    },
                    ticks: {
                        line: {
                            stroke: colors.grey[100],
                            strokeWidth: 1,
                        },
                        text: {
                            fill: colors.grey[100],
                        },
                    },
                },
                legends: {
                    text: {
                        fill: colors.grey[100],
                    },
                },
            }}
            margin={{ top: 50, right: 110, bottom: 80, left: 80 }}
            xScale={{ type: 'point' }}
            yScale={{
                type: 'linear',
                min: 0,
                max: 'auto'
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                legend: 'Date',
                legendOffset: 50,
                legendPosition: 'middle'
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Revenue',
                legendOffset: -60,
                legendPosition: 'middle'
            }}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'color', modifiers: [] }}
            pointLabelYOffset={-12}
            enableTouchCrosshair={true}
            useMesh={true}
            colors={{ scheme: "nivo" }}
            lineWidth={3}
            enableArea={true}
            areaOpacity={0.1}
            curve="monotoneX"
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemTextColor: colors.grey[100],
                    symbolSize: 12,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemTextColor: colors.greenAccent[500],
                            }
                        }
                    ]
                }
            ]}
        />
    );
});

export default LineChart;